module.exports = __webpack_public_path__ + "static/media/ukrainian-dill-potatoes-2652561_1280.59e68bf2.jpg";